import PropTypes from "prop-types"
import { Divider } from "@mui/material"
import { isNil, some } from "lodash"
import PositionRow from "./extraInfoPosition"
import InfoHeader from "./extraInfoHeader"
import { formatValueOrDash } from "helpers/assets/tooltips"

export default function ExtraInfo({
  economicExposure,
  basePercentEquity,
  positionPercentEquity,
  isUnmodeled,
  isActive,
  additionalItems = [],
}) {
  // Early return for cases where we shouldn't render anything
  const hasAnyData = economicExposure || basePercentEquity || positionPercentEquity || some(additionalItems, (item) => item.percentEquity)
  if (isUnmodeled || !hasAnyData) {
    return null
  }

  const showAnySizeColumn = !isNil(economicExposure) || some(additionalItems, (item) => !isNil(item.economicExposure))

  return (
    <div className="extra-info">
      <InfoHeader showSizeColumn={showAnySizeColumn} />
      <Divider />

      <PositionRow
        label="Position"
        percentEquity={positionPercentEquity}
        economicExposure={economicExposure}
        showSize={showAnySizeColumn}
      />

      {additionalItems.map((item) => (
        <PositionRow
          key={item.label}
          label={item.label}
          percentEquity={item.percentEquity}
          economicExposure={item.economicExposure}
          showSize={!isNil(item.economicExposure)}
        />
      ))}

      {isActive && (
        <div className="benchmark-row">
          <span>Benchmark</span>
          <span className="value">
            <span>{formatValueOrDash(basePercentEquity)}</span>
          </span>
          {showAnySizeColumn && <span className="value" />}
        </div>
      )}
    </div>
  )
}

ExtraInfo.propTypes = {
  economicExposure: PropTypes.number,
  basePercentEquity: PropTypes.number,
  positionPercentEquity: PropTypes.number,
  isUnmodeled: PropTypes.bool,
  isActive: PropTypes.bool,
  additionalItems: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    percentEquity: PropTypes.number,
    economicExposure: PropTypes.number,
  })),
}
